import { useEffect, useState } from "react";

import { IExtendedL3 } from "../services/NetworkApi";
import { useNetwork } from "./useNetwork";

interface UseMatchingRulesHandlerOptions {
  includeCount?: boolean;
}

export const useMatchingRulesHandler = (options: UseMatchingRulesHandlerOptions = {}) => {
  const { includeCount = false } = options;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<IExtendedL3[]>([]);
  const { getNetworkUnitTypes, getNetworkUnitTypesWithoutCount, selectedNetwork } = useNetwork();

  const getData = async () => {
    setIsLoading(true);
    const res = includeCount
      ? await getNetworkUnitTypes(selectedNetwork.l1Id)
      : await getNetworkUnitTypesWithoutCount(selectedNetwork.l1Id);
    setData(res);
    setIsLoading(false);
  };

  useEffect(() => {
    if (selectedNetwork.l1Id === 0) return;

    getData();
  }, [selectedNetwork.l1Id]);

  return {
    data,
    setData,
    getData,
    isLoading,
  };
};
